export const SET_EVENT = (state, data) => {
  state.event = data
}

export const SET_ONE_CHECKOUT_OPEN = (state, value) => {
  state.oneCheckoutOpen = value
}

export const SET_CHECKOUT_BY_PRODUCT = (state, value) => {
  state.checkoutByProduct = value
}

export const SET_LOADING_CHECKOUT = (state, value) => {
  state.loadingCheckout = value
}

export const SET_ALL_EVENT_PLACES = (state, value) => {
  state.eventPlaces = value
}

